import { useState, useEffect } from "react";

/**
 * Tiny responsive helper. Returns true when the viewport is narrower than `bp`
 * (default 768px). Used to compact the header + floating buttons on phones so
 * more of the map and products are visible.
 */
export default function useIsMobile(bp = 768) {
  const [mobile, setMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < bp : false
  );
  useEffect(() => {
    const onResize = () => setMobile(window.innerWidth < bp);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [bp]);
  return mobile;
}
